import type { AriaDatapointType, DataPointEventType } from 'owa-analytics-types';
import { lazyLogDatapoint } from '../lazyFunctions';
import { addStackTraceToEvent } from 'owa-analytics-utils/lib/addStackTraceToEvent';
import { cacheDatapointForDiagnostics } from '../utils/cacheDatapointForDiagnostics';

export function logDatapoint(
    datapoint: AriaDatapointType,
    overrideEventType?: DataPointEventType
): Promise<void> {
    prepareDatapointForLogging(datapoint);
    return lazyLogDatapoint.importAndExecute(datapoint, overrideEventType);
}

export function prepareDatapointForLogging(datapoint: AriaDatapointType): void {
    // Add original stack trace
    addStackTraceToEvent(datapoint.getOptions());

    // Enqueue into the rolling datapoint cache for ODS (if the addon is registered)
    cacheDatapointForDiagnostics(datapoint);
}
